module.exports = __webpack_public_path__ + "sx.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sx.svg
// module id = 1079
// module chunks = 0